import { IChainInfo } from '@kattana-io/common';
import Header from '../MainPage/Header';
import ChainPairsTable from './ChainPairsTable';
import Modal from '../../components/Modal';
import ChainSidebar from '../../components/SEO/Sidebar';
import ChainAbout from '../../components/SEO/About';
import { getChainStatistics } from './helpers';

interface ITokenProps {
  chain: IChainInfo;
  slug: string;
  title: string;
  logo: string;
}

const Chain = ({ chain, slug, title, logo }: ITokenProps) => {
  return (
    <div className='seo_page'>
      <Header chartPicker={false} />
      <div className='seo_page__content'>
        <div className='seo_page__about_token'>
          <div className='seo_page__main'>
            <ChainAbout
              title={title}
              subTitle={slug}
              slug={slug}
              description={`${title} is a highly scalable blockchain platform for DeFi, crypto dApps, and enterprise applications.`}
              logo={logo}
            />
            <ChainSidebar
              statisticsTitle={`${slug} Chain Statistics`}
              slug={slug}
              statistics={getChainStatistics(chain.chain)}
            />
          </div>
        </div>
        <ChainPairsTable pairs={Object.values(chain.pairs)} />
      </div>
      <Modal />
    </div>
  );
};

export default Chain;
